module.exports = __webpack_public_path__ + "static/media/vigencia-pasapets.71b0e57e.svg";